import { createContext, useContext } from "react";
import CommonStore from "./commonStore";
import UserStore from "./userStore";
import SettingStore from "./settingStore";
import GroupStore from "./groupStore";
import SyncLogStore from "./syncLogStore";
import ProductStore from "./productStore";
import VehicleStore from "./vehicleStore";
import ProductGuideStore from "./productGuideStore";

interface Store {
    commonStore: CommonStore;
    userStore: UserStore;
    settingStore: SettingStore;
    groupStore: GroupStore;
    syncLogStore: SyncLogStore;
    productStore: ProductStore;
    vehicleStore: VehicleStore;
    productGuideStore: ProductGuideStore;
}

export const store: Store = {
    commonStore: new CommonStore(),
    userStore: new UserStore(),
    settingStore: new SettingStore(),
    groupStore: new GroupStore(),
    syncLogStore: new SyncLogStore(),
    productStore: new ProductStore(),
    vehicleStore: new VehicleStore(),
    productGuideStore: new ProductGuideStore(),
}

export const StoreContext = createContext(store);

export function useStore() {
    return useContext(StoreContext);
}
